/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetPublicReservationInvoicePdfPathParameters } from 'api/actions/get-public-reservation-invoice-pdf/get-public-reservation-invoice-pdf-path-parameters';
import { GetPublicReservationInvoicePdfResponse } from 'api/actions/get-public-reservation-invoice-pdf/get-public-reservation-invoice-pdf-response';

type GetPublicReservationInvoicePdfQueryParameters = Record<string, any>;

/**
 * The path of the GetPublicReservationInvoicePdf action.
 */
export const getPublicReservationInvoicePdfActionPath = new SweetPath<
  keyof GetPublicReservationInvoicePdfPathParameters
>('/reservations/public/invoices/{accessToken}/pdf', { path: '{param}' });

/**
 * Creates a contextualized GetPublicReservationInvoicePdf actions.
 */
export default function createGetPublicReservationInvoicePdfAction(axios: AxiosInstance) {
  return function getPublicReservationInvoicePdfAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetPublicReservationInvoicePdfPathParameters;
    query?: GetPublicReservationInvoicePdfQueryParameters;
  }) {
    const path = getPublicReservationInvoicePdfActionPath.insert(parameters);

    return axios.get<GetPublicReservationInvoicePdfResponse, GetPublicReservationInvoicePdfResponse>(path, {
      params: query,
      headers,
      responseType: 'blob',
    });
  };
}
